<template>
    <div class="flex w-full flex-col bg-white">
        <div :class="['container pb-2 pt-5 md:py-4 lg:pb-4 lg:pt-7', { '!max-w-[100vw]': screen.maxSM }]">
            <div class="flex flex-col flex-wrap justify-between lg:flex-row">
                <div class="flex justify-between items-start mb-4 md:mb-5">
                    <BtnCta
                        v-if="document"
                        variant="tertiary"
                        left-icon="chevron-left"
                        :href="headerLinkUrl"
                        :label="headerLinkLabel"
                        size="sm"
                        :compact="screen.maxSM"
                    ></BtnCta>
                    <TagAI
                        v-if="document.has_ai_content && screen.maxMD"
                        data-testid="ai-extended"
                        :text="t('tags.aiText')"
                    >
                    </TagAI>
                </div>
                <DocumentShowMenu v-if="screen.minLG" />
                <div class="flex flex-row items-start md:w-full mb-3 md:mb-5">
                    <h1
                        style="word-break: break-word !important"
                        class="font-display-4 md:font-display-3 flex-1 line-clamp-3"
                        v-text="document.filename"
                    ></h1>
                    <TagAI
                        v-if="document.has_ai_content && screen.minLG"
                        v-tooltip="{
                            content: t('tooltip.aiTag'),
                            placement: 'left',
                        }"
                        data-testid="ai-extended"
                        :text="t('tags.aiText')"
                        class="ml-10"
                    ></TagAI>
                </div>
                <DocumentShowMenu v-if="screen.maxMD" />
            </div>
            <div
                v-if="screen.minLG"
                class="mb-3 hidden flex-nowrap lg:flex"
            >
                <div class="mr-4 flex items-center text-slate-600">
                    <i class="icon icon-documents"></i>
                    <span class="ml-2">{{ document.file_type_label }}</span>

                    <div
                        v-tooltip="{
                            content: document.description,
                            placement: 'bottom',
                        }"
                        class="cursor-pointer flex items-center"
                    >
                        <i class="icon icon-info ml-4 mr-1"></i>
                        <span class="">{{ t('show.description') }}</span>
                    </div>

                    <div
                        v-if="document.language?.name"
                        class="flex items-center whitespace-nowrap"
                    >
                        <i class="icon icon-globe-flat ml-4 mr-1"></i>
                        <span class="">{{ document.language?.name }}</span>
                    </div>
                </div>

                <div class="flex items-center">
                    <UserAvatar
                        :is-anonymous="document.user_data.anonymous"
                        :user-id="document.user_data.id"
                        :name="document.user_data.name"
                        :university="document.user_data.primary_university"
                        :animated-avatar="document.user_data.gamify_avatar_url"
                        :picture="document.user_data.profileBigPictureURL"
                        :karma-points="document.user_data.karmaPoints"
                        :link="
                            document.user_data.anonymous || userIsDeleted
                                ? null
                                : route('profile.show', {
                                      id: document.user_data.id,
                                      slug: document.user_data.slug,
                                  })
                        "
                        size="sm"
                        font-size="text-inherit"
                        show-details
                    ></UserAvatar>
                    <span class="ml-2 text-xs text-slate-400">
                        {{ document.time }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TagAI from '@/components/TagAi';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';
import DocumentShowMenu from './DocumentShowMenu.vue';

export default {
    name: 'DocumentShowHeader',
    components: {
        TagAI,
        DocumentShowMenu,
    },
    setup() {
        const { t } = useTranslation('document');
        return { t };
    },
    computed: {
        ...mapGetters({
            document: 'document/currentDocument',
            getLocale: 'ui/getLocale',
            screen: 'ui/screen',
        }),

        language() {
            return this.getLocale === 'de' ? 'de' : 'en';
        },
        userIsDeleted() {
            return !this.document.user_data.id;
        },
        documentCourse() {
            return this.document.course;
        },
        headerLinkUrl() {
            return this.documentCourse
                ? route('course.show', {
                      courseName: this.documentCourse.slug,
                      id: this.documentCourse.id,
                  })
                : route('dashboard.show');
        },

        headerLinkLabel() {
            return this.documentCourse
                ? this.t('document:show.label_course_link')
                : this.t('document:show.label_dashboard_link');
        },
    },
    methods: {
        route,
    },
};
</script>
